export type TemplateType =
  | 'agreement'
  | 'sow'
  | 'nda'
  | 'offer'
  | 'proposal'
  | 'cv'
  | 'email'
  | 'project_materials'
  | 'other';

export type DocumentStatus = 'draft' | 'rendered' | 'pending_signature' | 'signed' | 'void';
export type SigningMethod = 'native' | 'provider';

export const TEMPLATE_TYPES: { value: TemplateType; label: string }[] = [
  { value: 'agreement', label: 'Agreement' },
  { value: 'sow', label: 'Statement of Work' },
  { value: 'nda', label: 'NDA' },
  { value: 'offer', label: 'Offer letter' },
  { value: 'proposal', label: 'Proposal' },
  { value: 'cv', label: 'CV' },
  { value: 'email', label: 'Email' },
  { value: 'project_materials', label: 'Project Materials' },
  { value: 'other', label: 'Other' },
];

export const DOCUMENT_STATUSES: { value: DocumentStatus; label: string }[] = [
  { value: 'draft', label: 'Draft' },
  { value: 'rendered', label: 'Submitted' },
  { value: 'pending_signature', label: 'Pending signature' },
  { value: 'signed', label: 'Signed' },
  { value: 'void', label: 'Void' },
];

export const TEMPLATE_TYPE_LABEL: Record<TemplateType, string> = Object.fromEntries(
  TEMPLATE_TYPES.map((t) => [t.value, t.label]),
) as Record<TemplateType, string>;

export const DOCUMENT_STATUS_LABEL: Record<DocumentStatus, string> = Object.fromEntries(
  DOCUMENT_STATUSES.map((s) => [s.value, s.label]),
) as Record<DocumentStatus, string>;

/** Statuses that can be completed via native (in-app) signing. */
export const NATIVE_SIGNABLE: DocumentStatus[] = ['draft', 'rendered', 'pending_signature'];

/** Extract unique `{{ merge_field }}` names from a template body, in order. */
export function extractMergeFields(body: string): string[] {
  const seen = new Set<string>();
  for (const match of body.matchAll(/\{\{\s*([\w.]+)\s*\}\}/g)) {
    seen.add(match[1]);
  }
  return [...seen];
}
